import {
    Product,
    ProductContent,
    ProductItemBikini,
    ProductItemLook,
} from "@hermes/api-model-product";

export type ProductType = Product | ProductItemBikini | ProductItemLook;
export type ProductItemType = ProductItemBikini | ProductItemLook;
function isProduct(product: ProductType): product is Product {
    return product instanceof Product;
}

export function shouldDisplaySizeGuideButton(product: ProductType): boolean {
    if (product) {
        const productContent = isProduct(product)
            ? (product?.content as ProductContent)
            : product;

        return Boolean(productContent?.sizeGuideId);
    }
    return false;
}
